import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Comentario } from 'src/app/model/comentario';
import { Clausulas } from 'src/app/shared/models/formData.model';
import { Response } from 'src/app/shared/models/response.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { environment } from 'src/environments/environment.prod';
import { Parametros } from '../models/parametros';
import { Textos2 } from '../models/textos2';
import { FileParams } from '../models/filesParams';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionAvanzadaService {
  PHP_API_SERVER = environment.baseUrl;//"http://127.0.0.1:8080";
  constructor(private httpClient: HttpClient, private auth: AuthService) { }

  searchTodosIdiomas() {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/buscarTodosIdiomas.php`, {
    }, options);
  }

  searchAdvancedParam(id_sociedad: string): Observable<Response<Parametros>> {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post<Response<Parametros>>(
      `${this.PHP_API_SERVER}/api/buscarConfiguracionParametros.php`, {
      id_sociedad: id_sociedad,
    }, options);
  }

  searchComplaintsByYear() {
    return this.httpClient.get<{ areThereComplaints: number }>(`${this.PHP_API_SERVER}/api/Denuncias/searchComplaintsByYear.php`);
  }

  searchSSOdParam(id_sociedad: string): Observable<Response<Parametros>> {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post<Response<Parametros>>(`${this.PHP_API_SERVER}/api/buscarSSOParametros.php`, {
      id_sociedad,
    }, options);
  }

  searchTextos(id_texto: string, idioma: string, id_sociedad: string): Observable<Response<Textos2[]>> {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post<Response<Textos2[]>>(`${this.PHP_API_SERVER}/api/buscarTextos.php`, {
      id_texto,
      idioma,
      id_sociedad,
    }, options);
  }

  searchClausulas(id_clausula: string, id_sociedad: string): Observable<Response<Clausulas>> {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post<Response<Clausulas>>(
      `${this.PHP_API_SERVER}/api/buscarClausulas.php`, {
      id_clausula: id_clausula,
      id_sociedad: id_sociedad,
    }, options);
  }

  searchTextos2(id_texto: string, seguro: boolean, idioma: string, id_sociedad: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/getTextos.php`, {
      id_texto: id_texto,
      seguro: seguro,
      idioma: idioma,
      id_sociedad: id_sociedad,
    }, options);
  }

  searchCustomTextos(id_texto: string, seguro: boolean, idioma: string, id_sociedad: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/textos/getCustomizableTexts.php`, {
      id_texto: id_texto,
      seguro: seguro,
      idioma: idioma,
      id_sociedad: id_sociedad,
    }, options);
  }


  searchClausulas2(id_clausula: string, seguro: boolean, id_sociedad: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/getClausulas.php`, {
      id_clausula: id_clausula,
      seguro: seguro,
      id_sociedad: id_sociedad,
    }, options);
  }

  updateAdvancedParam(id_sociedad: string, anonimo: string, dominio: string, consultas: string, plazo: string, clausulas: string, conflicto: string, diasinves: string, diasdecisor: string, diascompliance: string, diasverdenuncia: string, triaje: string, centros: string, inputAutocomplete: string, popUp: string, selectedDrive: string, rutaDrive: string, daysreception: string, emailSupport: string, supportForm: string, conflictoCompliance: string, documentPreview: string, complianceNotification: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/advanced-settings/updateParamsGlob.php`, {
      id_sociedad: id_sociedad,
      anonimo: anonimo,
      dominio: dominio,
      consultas: consultas,
      plazo: plazo,
      clausulas: clausulas,
      conflicto: conflicto,
      diasinves: diasinves,
      diasdecisor: diasdecisor,
      diascompliance: diascompliance,
      diasverdenuncia: diasverdenuncia,
      popUp: popUp,
      triaje: triaje,
      centros: centros,
      inputAutocomplete: inputAutocomplete,
      rutaDrive: rutaDrive,
      daysreception: daysreception,
      emailSupport,
      supportForm: supportForm,
      conflictoCompliance: conflictoCompliance,
      documentPreview: documentPreview,
      complianceNotification: complianceNotification
    }, options);
  }

  updateAdvancedParam3(id_sociedad: string, colorprincipal: string, colorsecundario: string, colorbgseccion2: string, colorbgseccion3: string, colortxtbtn: string, colortxtseccion1: string, colortxtseccion2: string, colortxtseccion3: string, colortxttitulo: string, colorbgseccion1: string, colormenulateral: string, colortxtcabeceras: string, colortxtbotones: string, colortxtFondo: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/crearConfiguracionParametros3.php`, {
      id_sociedad: id_sociedad,
      colorprincipal: colorprincipal,
      colorsecundario: colorsecundario,
      colorbgseccion2: colorbgseccion2,
      colorbgseccion3: colorbgseccion3,
      colortxtbtn: colortxtbtn,
      colortxtseccion1: colortxtseccion1,
      colortxtseccion2: colortxtseccion2,
      colortxtseccion3: colortxtseccion3,
      colortxttitulo: colortxttitulo,
      colorbgseccion1: colorbgseccion1,
      colormenulateral: colormenulateral,
      colortxtcabeceras: colortxtcabeceras,
      colortxtbotones: colortxtbotones,
      colortxtFondo: colortxtFondo
    }, options);
  }

  updateAdvancedParam2(id_sociedad: string, nremitente: string, remitente: string, srv_mail: string, puerto: string, usr_mail: string, pass_mail: string, ssl: string, auth_mail: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/crearConfiguracionParametros2.php`, {
      id_sociedad: id_sociedad,
      nremitente: nremitente,
      remitente: remitente,
      srv_mail: srv_mail,
      puerto: puerto,
      usr_mail: usr_mail,
      pass_mail: pass_mail,
      ssl: ssl,
      auth_mail: auth_mail,
    }, options);
  }

  updateAdvancedParam4(id_sociedad: string, multi: string, tieneSSO: string, archivardenuncia: string, idPersonalizableEnabled: string, gAnalyticsEnabled: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/crearConfiguracionParametros4.php`, {
      id_sociedad: id_sociedad,
      multi: multi,
      tieneSSO: tieneSSO,
      archivardenuncia: archivardenuncia,
      idPersonalizableEnabled: idPersonalizableEnabled,
      gAnalyticsEnabled: gAnalyticsEnabled
    }, options);
  }

  // Service to update parameters related to personalized identifier
  updateIdentifierParams(id_sociedad: string,
    include_characters: string,
    identifier_characters: string,
    include_year: string,
    identifier_year: string,
    reset_numbering: string,
    custom_reset_date: string,
    custom_reset_date_value: string
  ) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/advanced-settings/updateAdvancedSettings.php`, {
      id_sociedad: id_sociedad,
      include_characters: include_characters,
      identifier_characters: identifier_characters,
      include_year: include_year,
      identifier_year: identifier_year,
      reset_numbering: reset_numbering,
      custom_reset_date: custom_reset_date,
      custom_reset_date_value: custom_reset_date_value
    }, options);
  }

  /**
   * @Description Check if the identifier configuration is unique across societies
   */
  checkIdentifierUnique(
    id_sociedad: string,
    identifierCharacters: string,
    identifierYear: string,
    customResetDateValue: string
  ): Observable<any> {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() };
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/advanced-settings/checkIdentifierUnique.php`, {
      id_sociedad: id_sociedad,
      identifierCharacters: identifierCharacters,
      identifierYear: identifierYear,
      customResetDateValue: customResetDateValue
    }, options);
  }

  // Servce to save idClienteAnalytics
  saveIdClientGAnalytics(id_sociedad: string, idClienteAnalytics: string): Observable<any> {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/advanced-settings/saveIdClientGAnalytics.php`, {
      id_sociedad: id_sociedad,
      idClienteAnalytics: idClienteAnalytics
    }, options);
  }

  ///METHOD TO UPDATE saml enabled
  updateSamlEnabled(id_sociedad: string, saml_enabled: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() };
    let options = { headers: headers };


    return this.httpClient.post(`${this.PHP_API_SERVER}/api/updateSamlEnabled.php`, {
      id_sociedad: id_sociedad,
      saml_enabled: saml_enabled,
    }, options);
  }


  updateTextos(id_texto: string, texto: string, idioma: string, id_sociedad: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/crearTextos.php`, {
      id_texto: id_texto,
      texto: texto,
      idioma: idioma,
      id_sociedad: id_sociedad,
    }, options);
  }

  generarFicheroTextos(idioma: string, id_sociedad: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/generarFicheroTextos.php`, {
      idioma: idioma,
      id_sociedad: id_sociedad,
    }, options);
  }

  updateClausulas(id_clausula: string, clausula: string, id_sociedad: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/crearClausulas.php`, {
      id_clausula: id_clausula,
      clausula: clausula,
      id_sociedad: id_sociedad,
    }, options);
  }

  updateSSOParam(id_sociedad: string, saml_enabled: string, saml_idp_entity_id: string, saml_idp_sso_url: string, saml_idp_slo: string, saml_idp_cert: string, saml_idp_cert2: string, saml_mapping_cn: string, saml_mapping_sn: string, saml_mapping_email: string, saml_mapping_phone: string, saml_mapping_national_id: string, saml_jit: string, saml_slo: string, saml_force_login: string, saml_debug: string, saml_sp_entity_id: string, saml_sp_pk: string, saml_sp_cert: string, saml_sp_nameid_format: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/crearConfiguracionSSO.php`, {
      id_sociedad: id_sociedad,
      saml_enabled: saml_enabled,
      saml_idp_entity_id: saml_idp_entity_id,
      saml_idp_sso_url: saml_idp_sso_url,
      saml_idp_slo: saml_idp_slo,
      saml_idp_cert: saml_idp_cert,
      saml_idp_cert2: saml_idp_cert2,
      saml_mapping_cn: saml_mapping_cn,
      saml_mapping_sn: saml_mapping_sn,
      saml_mapping_email: saml_mapping_email,
      saml_mapping_phone: saml_mapping_phone,
      saml_mapping_national_id: saml_mapping_national_id,
      saml_jit: saml_jit,
      saml_slo: saml_slo,
      saml_force_login: saml_force_login,
      saml_debug: saml_debug,
      saml_sp_entity_id: saml_sp_entity_id,
      saml_sp_pk: saml_sp_pk,
      saml_sp_cert: saml_sp_cert,
      saml_sp_nameid_format: saml_sp_nameid_format,
    }, options)
  }


  updateIdioma(id_idioma: string, n_idioma: string, comentario: string, Habilitado: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/modificarIdioma.php`, {
      id_idioma: id_idioma,
      n_idioma: n_idioma,
      comentario: comentario,
      Habilitado: Habilitado
    }, options);
  }

  /**
   * Update only the parameters related to terms/policies/buttons
   */
  updateFilesParams(params: FileParams): Observable<Response<any>> {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() };
    const options = { headers: headers };

    return this.httpClient.post<Response<any>>(`${this.PHP_API_SERVER}/api/advanced-settings/updateParametersFiles.php`, params, options);

  }

  uploadAdvancedSettingsFiles(formData: FormData): Observable<Response<any>> {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() };
    const options = { headers: headers };

    return this.httpClient.post<Response<any>>(`${this.PHP_API_SERVER}/api/advanced-settings/uploadAdvancedSettingsFiles.php`, formData, options);
  }

  uploadFiles(formData: FormData) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() };
    const options = { headers: headers };

    // Do not set Content-Type header; the browser will add the proper multipart boundary.
    return this.httpClient.post(`${this.PHP_API_SERVER}/api/uploadSettingFiles.php`, formData, options);
  }

  uploadImages(formData: FormData) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/upload_images.php`, formData, options)
  }
}
